
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"16.5","y":"2","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M16 17.5h16","stroke":"currentColor","stroke-width":".923","stroke-linecap":"round"}}),_c('rect',{attrs:{"x":"18.5","y":"22","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}})])
          )
        }
      }
    